import { render, staticRenderFns } from "./TrimmingFreeHand.vue?vue&type=template&id=6d11bcee&scoped=true&"
import script from "./TrimmingFreeHand.vue?vue&type=script&lang=js&"
export * from "./TrimmingFreeHand.vue?vue&type=script&lang=js&"
import style0 from "./TrimmingFreeHand.vue?vue&type=style&index=0&id=6d11bcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11bcee",
  null
  
)

export default component.exports